<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <button-add @click="toAddPage" v-if="permissionCodes.indexOf('036002001') !== -1"></button-add>
        <button-delete @deleteSelection="deleteSelection" v-if="permissionCodes.indexOf('036002003') !== -1"/>
        <button-upload
          value="导入"
          v-if="permissionCodes.indexOf('036002004') !== -1"
          :cathUrl="uploadUrl"
          :onSuccess="onUploadSuccess"
          @getpage="getPage" />
      </div>
    <div style="display: flex;justify-content: space-between">
      <input-search  placeholder="物资名称/物资编号"  @search="searchKey"/>
        <button-export
        :href="exportUrl"
        :beforeDownload="beforeDownload"
        style="margin: 0 0 0 8px"
        download="download.xls"
        value="导出"/>
    </div>
  </div>
      <div class="search-line">
        <div class="btn-box">
          <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">入库时间</span>
          <el-date-picker v-model="timevalue1"  size="small" type="daterange" style="width: 280px;" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          align="right" value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
        <div>
          <input-select selectTitle="物资类目" :selectKey="'categoryCode'" :selectData="categoryTypeList" style="margin:0 20px" @search="search"/>
        </div>
        <div class="btn-box">
          <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">维保截止时间</span>
          <el-date-picker v-model="timevalue2" size="small" type="daterange" style="width: 280px;" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          align="right" value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
      </div>
    <table-main :tableHead="tableHead" :tableData="tableData" :operationArr="operationArr" @deleteLine="deleteLine" @changeSelection="changeSelection" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :total="total" @goToModifyPage="goToModifyPage"></table-main>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Material";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nAlert, nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "warehousing-management",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "物资管理",
          name: "material-category-manage"
        },
        {
          value: "入库管理"
        }
      ],
      fixTypeList: [],
      tableHead: [
        {
          prop: "materialsName",
          label: "物资名称"
        },
        {
          prop: "categoryName",
          label: "物资类目"
        },
        {
          prop: "materialsNumber",
          label: "物资编号"
        },
        {
          prop: "specification",
          label: "规格型号"
        },
        {
          prop: "storeNumber",
          label: "数量"
        },
        {
          prop: "measureUnit",
          label: "计量单位"
        },
        {
          prop: "maintenanceDate",
          label: "维保截止时间"
        },
        {
          prop: "storeDate",
          label: "入库时间"
        },
        {
          prop: "memo",
          label: "备注"
        }
      ],
      categoryTypeList: [],
      tableData: [],
      requestData: {
        pageSize: 10,
        pageNum: 1,
        searchKey: "",
        categoryCode: "",
        startTime: "",
        endTime: "",
        mtStartTime: "",
        mtEndTime: ""
      },
      operationArr: ["modify", "delete"],
      selectionArr: [],
      uploadUrl: "",
      exportUrl: "",
      timevalue1: [],
      timevalue2: [],
      total: 0
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
    this.getCategoryList();
    this.uploadUrl = api.importStore;
  },
  activated() {
    this.getPage();
    this.getCategoryList();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportStore}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&categoryCode=${this.requestData.categoryCode}&startTime=${
        this.requestData.startTime
      }&endTime=${this.requestData.endTime}&mtStartTime=${
        this.requestData.mtStartTime
      }&mtEndTime=${this.requestData.mtEndTime}`;
    },
    getCategoryList(searchKey) {
      this.$axios
        .post(api.getCategoryList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            list.map(v => {
              v.key = v.code;
              v.label = v.categoryName;
            });
            this.categoryTypeList = list;
            console.log(this.categoryTypeList);
            this.categoryTypeList.unshift({ key: "", label: "全部" });
          }
        })
        .catch(errorHandler("获取物资类目列表失败"));
    },
    getPage() {
      if (this.timevalue1) {
        // console.log(this.timevalue1);
        this.requestData.startTime = this.timevalue1[0] || "";
        this.requestData.endTime = this.timevalue1[1] || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      if (this.timevalue2) {
        // console.log(this.timevalue2);
        this.requestData.mtStartTime = this.timevalue2[0] || "";
        this.requestData.mtEndTime = this.timevalue2[1] || "";
      } else {
        this.requestData.mtStartTime = "";
        this.requestData.mtEndTime = "";
      }

      this.$axios
        .post(api.getStorePage, this.requestData)
        .then(res => {
          // console.log(res);
          let list = res.data.data.list;
          this.total = res.data.data.total;
          this.tableData = list;
        })
        .catch(errorHandler("获取分页失败"));
    },
    toAddPage() {
      this.$router.push({
        name: "warehousing-management-add"
      });
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    deleteSelection() {
      if (this.selectionArr.length === 0) {
        nAlert("请先选择需要删除的物资");
        return false;
      } else {
        this.$confirm("是否确认删除物资？", "提示")
          .then(() => {
            this.deleteLine(this.selectionArr);
          })
          .catch(() => {
            console.log("取消删除");
          });
      }
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteStoreByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `/warehousing_management_modify/${code}`
      });
    }
  },
  watch: {
    timevalue1() {
      this.getPage();
    },
    timevalue2() {
      this.getPage();
    }
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/MaterialManagement/WarehousingManagement/WarehousingManagement.vue